


































  import { Component, Vue } from 'vue-property-decorator'
  import { Prop } from 'nuxt-property-decorator'

  @Component
  export default class OneRelatedProductsList extends Vue {
    @Prop({
      type: String,
      required: true,
    })
    title!: string

    @Prop({
      type: Array,
      required: true,
    })
    products!: string[]

    @Prop({
      type: Boolean,
      required: true,
    })
    loading!: boolean

    DEFAULT_COUNTER_LENGTH = 3
    counter = this.DEFAULT_COUNTER_LENGTH

    setProductsToShow() {
      this.counter = this.counter + 10
    }

    resetCounter() {
      this.counter = this.DEFAULT_COUNTER_LENGTH
    }
  }
